<template>
  <div class="common-button-icon">
    <button
      v-if="!isLoading"
      type="button"
      @click="handleClick"
      :class="{
        'cursor-default': disabled,
        [customClassName]: customClassName
      }"
      :disabled="disabled"
    >
      <v-icon size="20" :color="renderButtonColor">{{ icon }}</v-icon>
    </button>
    <div v-else class="d-flex align-center">
      <v-progress-circular
        indeterminate
        color="#9e9e9e"
        class="ml-1 mt-4"
        size="15"
        width="2"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
const Colors = {
  DISABLED: "#0000001A",
  ACTIVE: "#9e9e9e"
};

export default {
  name: "CommonButtonIcon",
  props: {
    icon: {
      type: String,
      required: true
    },
    handleClick: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    customClassName: {
      type: String,
      default: ""
    }
  },

  computed: {
    renderButtonColor() {
      return this.disabled ? Colors.DISABLED : Colors.ACTIVE;
    }
  }
};
</script>

<style scoped>
.common-button-icon {
  min-width: 20px !important;
  margin: 0 5px;
}

.cursor-default {
  cursor: default;
}
</style>
